import { createRouter, createWebHistory, createWebHashHistory } from '@ionic/vue-router'
import { RouteRecordRaw } from 'vue-router'
import { routerAuthGuard } from '@/plugins/w/router'
import { routes as lzRoutes } from './lz.router'
import { routes as ocRoutes } from './oc.router'
import { routes as paymentRoutes } from './payment.router'
import { ApplicationMode, useApplication } from '../../composables/application.composable'

const applicationRoutes: Array<RouteRecordRaw> = []
const { mode } = useApplication()

switch (mode.value) {
	case ApplicationMode.OC:
		applicationRoutes.push(...ocRoutes)
		break
	case ApplicationMode.LZ:
		applicationRoutes.push(...lzRoutes)
		break
	case ApplicationMode.PAYMENT:
		applicationRoutes.push(...paymentRoutes)
		break
	default:
		applicationRoutes.push(...lzRoutes)
		break
}

const routes: Array<RouteRecordRaw> = [
	...applicationRoutes,
	{
		path: '/',
		component: () => import('@/plugins/app/layout/auth/auth.layout.vue'),
		children: [
			{
				path: '/:pathMatch(.*)*',
				name: '404',
				component: () => import('@/plugins/app/views/error/error.vue'),
				meta: { requiresAuth: null }
			},
			{
				path: 'error',
				name: '500',
				component: () => import('@/plugins/app/views/error/error.vue'),
				meta: { requiresAuth: null }
			},
			{
				path: 'udrzba',
				name: '503',
				component: () => import('@/plugins/app/views/maintenance/maintenance.vue')
			}
		]
	}
]

const router = createRouter({
	history: import.meta.env.NODE_ENV == 'development' ? createWebHashHistory(import.meta.env.BASE_URL) : createWebHistory(import.meta.env.BASE_URL),
	routes
})

router.beforeEach((to, from, next) =>
	routerAuthGuard(
		{
			isAuthentificated: { name: 'App' },
			isNotAuthentificated: { name: 'Login' },
			termsNotAccepted: { name: 'Login - Podmienky' }
		},
		{ to, from, next }
	)
)

export default router
